import { ModalProvider } from "@stainless-code/react-modal-manager";
import { CommandMenu } from "@/components/admin/CommandMenu";
import { cn } from "@/lib/utils";
import { SearchProvider } from "@/providers/search-provider";
import { SidebarProvider } from "../ui/sidebar";
import { AppSidebar } from "./AppSidebar/AppSidebar";

type AdminLayoutProps = {
	children: React.ReactNode;
};

export const AdminLayout = ({ children }: AdminLayoutProps) => (
	<SearchProvider>
		<SidebarProvider>
			<a
				className="fixed left-44 z-999 -translate-y-52 whitespace-nowrap bg-primary px-4 py-2 font-medium text-primary-foreground text-sm opacity-95 shadow transition hover:bg-primary/90 focus:translate-y-3 focus:transform focus-visible:ring-1 focus-visible:ring-ring"
				href="#content"
			>
				Skip to Main
			</a>

			<AppSidebar />

			<div
				className={cn(
					"ml-auto w-full max-w-full",
					"peer-data-[state=collapsed]:w-[calc(100%-var(--sidebar-width-icon))]",
					"peer-data-[state=expanded]:w-[calc(100%-var(--sidebar-width))]",
					"transition-[width] duration-200 ease-linear",
					"flex h-svh flex-col"
				)}
				id="content"
			>
				<ModalProvider>
					{children}
					<CommandMenu />
				</ModalProvider>
			</div>
		</SidebarProvider>
	</SearchProvider>
);
